/**
 * created by mgg
 *约稿管理
 */
import React, {Component} from 'react';
import {Tabs, Input, Modal, Pagination, Button, Row, Col} from 'antd';
import ManagementTable from "../../components/managementTable/ManagementTable";

const {TabPane} = Tabs;
const {Search} = Input;
const {confirm} = Modal;

export default class AppointmentManagement extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            watchVisible:false,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <div>
                    {this.renderHeader()}
                    {this.renderWatch()}
                </div>
            </div>
        )
    };

    //页头
    renderHeader() {
        return (
            <div style={{width: 1640, background: "#fff", opacity: 1, borderRadius: '5', margin: "0 auto"}}>
                <div style={{width: 1575,height: '100%', background: "#fff",margin:"0 auto"}}>
                    <Tabs defaultActiveKey="1" style={{height: 1000}}>
                        <TabPane tab="全部" key="1">
                            {this.renderTable()}
                        </TabPane>
                        <TabPane tab="未领取" key="2">
                            {this.renderTable()}
                        </TabPane>
                        <TabPane tab="已领取" key="3">
                            {this.renderTable()}
                        </TabPane>
                        <TabPane tab="已回稿" key="4">
                            {this.renderTable()}
                        </TabPane>
                    </Tabs>
                    <div>
                    </div>
                </div>
            </div>
        )
    };

    //表格
    renderTable() {
        const columns = [
            {
                title: '序号',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
            },
            {
                title: '稿件要求',
                dataIndex: 'request',
                key: 'request',
                align: 'center',
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                key: 'createTime',
                align: 'center',
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render:(text,record)=>{
                    let color = '';
                    if(record.status === '未领取'){
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background:"#F56C6C",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>未领取</span>
                        </div>
                    }else if(record.status === '已领取'){
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background:"#89D069",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>已领取</span>
                        </div>
                    }else if(record.status === '已回稿'){
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background:"#0050B3",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>已回稿</span>
                        </div>
                    }
                }
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                align: 'center',
                render:(text,record)=>(
                    <a type="primary" onClick={()=>this.setState({watchVisible:true})} style={{marginRight:10}}>查看</a>
                )
                /* render:(text,record)=>{
                     let statusText = '';
                         if(record.status === '未领取'){
                             statusText = <div>
                                 <a type="primary" onClick={()=>this.setState({watchVisible:true})} style={{marginRight:10}}>查看</a>
                                 <a type="primary" onClick={()=>this.receive()} style={{marginRight:10}}>领取</a>
                                 <a type="primary" onClick={()=>this.refuse()}>拒绝</a>
                             </div>
                         }else if(record.status === '已领取'){
                             statusText = <div>
                                 <a type="primary" onClick={()=>this.watch()} style={{marginRight:10}}>查看</a>
                                 <a type="primary" onClick={()=>this.write()}>写稿</a>
                             </div>
                         }else if(record.status === '已回稿'){
                             statusText = <div>
                                 <a type="primary" onClick={()=>this.watch()} style={{marginRight:10}}>查看</a>
                                 <a type="primary" onClick={()=>this.view()}>查看稿件</a>
                             </div>
                         }
                 }*/
            },
        ];
        const dataSource = [];
        for (let i = 1; i <= 10; i++) {
            dataSource.push(
                {
                    key: i,
                    id: i,
                    request: '这是一个稿件要求',
                    createTime: '2021-7-8',
                    status: '已采用',
                }
            )
        };
        return (
            <div>
                <div style={{marginTop:15}}>
                        <Search placeholder="请输入关键词" onSearch={this.onSearch} style={{width:200,float:"left",marginBottom:15}}/>
                </div>
                <div>
                    <div style={{marginTop:15,height:"1000px"}}>
                        <ManagementTable
                            columns={columns}
                            dataSource={dataSource}
                        />
                    </div>
                </div>
            </div>
        )
    };

    //页脚
    renderFooter(){
        return(
            <div style={{display: 'flex', justifyContent: "flex-end", marginTop: 20}}>
                <Pagination defaultCurrent={1} total={50} />
            </div>
        )
    };

    //查看modal
    renderWatch(){
        return(
            <div>
                <Modal
                    title="查看约稿任务"
                    visible={this.state.watchVisible}
                    onOk={()=>this.save()}
                    onCancel={()=>{this.setState({watchVisible:false})}}
                    centered={true}
                    width={600}
                    footer={
                        <div style={{textAlign:"center"}}>
                            <Button>取消</Button>
                            <Button style={{background:"#0050B3",color:"#fff"}}>确定</Button>
                        </div>
                    }
                >
                    <div style={{textAlign:"center"}}>
                        <Button style={{marginRight:15,backgroundImage: 'url(images/selected.png)',width:74,height:32,border:"#0050B3"}}>领取</Button>
                        <Button style={{width:74,height:32}}>拒绝</Button>
                    </div>
                  <div style={{marginTop:20,}}>
                      <Row style={{marginTop:10}}>
                          <Col span={8} style={{textAlign:"right",marginRight:10,color:"rgba(0, 0, 0, 0.45)"}}>要求回稿时间：</Col>
                          <Col span={11} style={{color:"rgba(0, 0, 0, 0.85)"}}>2021-05-13</Col>
                      </Row>
                      <Row style={{marginTop:10}}>
                          <Col span={8} style={{textAlign:"right",marginRight:10,color:"rgba(0, 0, 0, 0.45)"}}>稿件要求：</Col>
                          <Col span={11} style={{color:"rgba(0, 0, 0, 0.85)"}}>要求</Col>
                      </Row>
                      <Row style={{marginTop:10}}>
                          <Col span={8} style={{textAlign:"right",marginRight:10,color:"rgba(0, 0, 0, 0.45)"}}>创建时间：</Col>
                          <Col span={11} style={{color:"rgba(0, 0, 0, 0.85)"}}>2021-8-6</Col>
                      </Row>
                      <Row style={{marginTop:10}}>
                          <Col span={8} style={{textAlign:"right",marginRight:10,color:"rgba(0, 0, 0, 0.45)"}}>发布媒体：</Col>
                          <Col span={11} style={{color:"rgba(0, 0, 0, 0.85)"}}>新浪、微博</Col>
                      </Row>
                      <Row style={{marginTop:10}}>
                          <Col span={8} style={{textAlign:"right",marginRight:10,color:"rgba(0, 0, 0, 0.45)"}}>发布者：</Col>
                          <Col span={11} style={{color:"rgba(0, 0, 0, 0.85)"}}>通讯员通讯员</Col>
                      </Row>
                  </div>
                </Modal>
            </div>
        )
    };

   //保存查看
    save = () => {
        this.setState({
            watchVisible:false,
        })
    }

}